import { useEffect, useState, useRef } from 'react';
import { hysteriFetch, wrappers } from 'hysterics';
import { setNewRelicCustomAttribute } from '@ddc/new-relic';
import { sanitizeListingConfigId } from '../utils/submitSearchUtils';

const suggestionsFetchWrapper = hysteriFetch(
	'ws-inv-text-search-suggestions-proxy-fetch'
);

const apiURL = '/api/widget/ws-inv-text-search/getSuggestions';

// TODO use Suspense instead of hook to fetch data, when Suspense is ready
// https://reactjs.org/docs/concurrent-mode-suspense.html
const useFreeFormSearchServiceApi = (input, siteId) => {
	const [response, setResponse] = useState(null);
	const [fetchError, setError] = useState(null);
	const requestCounterRef = useRef(0);

	useEffect(() => {
		if (input) {
			// Reset response and error when input changes
			setResponse(null);
			setError(null);

			// Increment request counter and capture it for this request
			requestCounterRef.current += 1;
			const currentRequestId = requestCounterRef.current;

			(async () => {
				const listingConfigIdPref =
					window.DDC?.InvData?.prefs?.['listing.config.id'] || '';
				const listingConfigId =
					sanitizeListingConfigId(listingConfigIdPref);
				const queryString = `?searchTerm=${encodeURIComponent(
					input
				)}&siteId=${encodeURIComponent(
					siteId
				)}&listingConfigId=${encodeURIComponent(listingConfigId)}`;
				const searchUrl = `${apiURL}${queryString}`;
				try {
					const searchResults = await suggestionsFetchWrapper(
						searchUrl,
						{
							method: 'GET'
						},
						{
							[wrappers.timeout.contextKey]: {
								timeout: 2500
							},
							[wrappers.retry.contextKey]: {
								retries: 0
							}
						}
					);

					// Only update state if this is still the latest request
					if (currentRequestId === requestCounterRef.current) {
						setNewRelicCustomAttribute(
							'wsInvTextSearchInput',
							input
						);
						setNewRelicCustomAttribute(
							'wsInvTextSearchInputNumResults',
							searchResults?.suggestions?.[0]?.count > 0
								? searchResults.suggestions.length
								: 0
						);
						setResponse(searchResults);
						setError(null);
					}
				} catch (err) {
					// Only update error if this is still the latest request
					if (currentRequestId === requestCounterRef.current) {
						setError(err);
						setResponse({}); // Set empty response so fetch is considered complete
					}
				}
			})();
		} else {
			setResponse(null);
		}
	}, [input, siteId]);
	return [response, fetchError];
};

export default useFreeFormSearchServiceApi;
